import React, { useState, useEffect } from 'react';
import { Modal, Row, Button } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';//props传参检查库
import trans from './translation';
import { Config } from '../../public/js/config';

import './popupFrame.css';

/**
 * 确认弹框组件
 * props传参如下
 * @param content:消息内容（不传默认为"删除"）
 * @param close:关闭弹框时修改弹框显示状态的回调方法
 */
const PopupFrame = (props) => {

    const [content, setContent] = useState("");
    const types = {
        delete : trans.confirmDelete[Config.backLang]
        ,leave : trans.confirmLeave[Config.backLang]
        ,sysfunc:trans.sysfunc[Config.backLang]
    };
    const deleteTipText = useState(props?.deleteTipText);


    useEffect(() => {
        if(typeof close !== "function") {
            throw new Error(trans.OffCallBack[Config.backLang]);
        }
        setContent(props?.content ?? types[props?.type ?? 'delete']);
    }, []);

    const closeFrame = (state) => {
        props.close(state);
    }

    return (
        <Row>
            <Modal
                closable={false}
                className="popupFrameAlign"
                width={!props?.content ? "400px" : "600px"}
                visible={true}
                onCancel={() => {closeFrame(false)}}
                footer={[
                    <Button className="sysBtn btnBlue" key='save' type="primary" onClick={() => closeFrame(true)} icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>,
                    <Button key='cancel' className="sysBtn" onClick={() => closeFrame(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                ]}
            >
                { deleteTipText &&
                    <div className="popupFrameText">{deleteTipText}</div>
                }
                <div className="popupFrameCenter">{content}</div>
            </Modal>
        </Row>
    )
}

/**
 * props参数检查
 */
PopupFrame.propTypes = {
    type: PropTypes.string
    ,content: PropTypes.string
    ,close: PropTypes.func.isRequired
    ,deleteTipText: PropTypes.string
};

export default PopupFrame;